import common from './common'
import * as AutoKana from 'vanilla-autokana';

//入力値をストアに保持
function inputRetention(obj) {
    obj.name.sei_kj = common.getStore(obj, 'sei_kj')
    obj.name.mei_kj = common.getStore(obj, 'mei_kj')
    obj.name.sei_kn = common.getStore(obj, 'sei_kn')
    obj.name.mei_kn = common.getStore(obj, 'mei_kn')
    obj.pickupTell = common.getStore(obj, 'pickupTell')
    obj.pickupTell2 = common.getStore(obj, 'pickupTell2')
    obj.email = common.getStore(obj, 'email')
    let enquete = common.getStore(obj, 'enquete')
    if (Object.keys(enquete).length > 0) {
        obj.selected = enquete.selected
        obj.freeInput = enquete.freeInput
    }

    // 法人サイトの場合
    if(obj.siteCodeInfo[0].BIZ_FLG == '1'){
        obj.checkContractor = common.getStore(obj, 'checkContractor')
        obj.contractorName.sei_kj = common.getStore(obj, 'contractorSei_kj')
        obj.contractorName.mei_kj = common.getStore(obj, 'contractorMei_kj')
        obj.contractorName.sei_kn = common.getStore(obj, 'contractorSei_kn')
        obj.contractorName.mei_kn = common.getStore(obj, 'contractorMei_kn')
        obj.contractCompanyName = common.getStore(obj, 'contractCompanyName')
        obj.contractDepartment = common.getStore(obj, 'contractDepartment')
        obj.contractCompanyZipcode = common.getStore(obj, 'contractCompanyZipcode')
        obj.contractCompanyAddress = common.getStore(obj, 'contractCompanyAddress')
        obj.contractCompanyTell = common.getStore(obj, 'contractCompanyTell')    
        obj.companyName = common.getStore(obj, 'companyName')
        obj.department = common.getStore(obj, 'department')
        let codeInfo = common.getStore(obj, 'codeInfo')
        obj.employees = codeInfo.employees
        obj.industries = codeInfo.industries
        obj.selectEmployee = common.getStore(obj, 'selectEmployee')
        obj.selectIndustry = common.getStore(obj, 'selectIndustry')
    }else{
        obj.gender = common.getStore(obj, 'gender')
        let birthday = common.getStore(obj, 'birthday')
        if (birthday != null) {
            let birthdayDate = new Date(birthday)
            obj.birthday.year = birthdayDate.getFullYear()
            obj.birthday.month = birthdayDate.getMonth() + 1
            obj.birthday.date = birthdayDate.getDate()
        }
    }
}

//生年月日の選択肢作成
function createBirthday(obj) {
    let date = new Date()
    let firstYear = common.constant.BIRTHDAY_FIRST_YEAR
    let lastYear = date.getFullYear() - common.constant.BIRTHDAY_LAST_YEAR_ADJUST
    //'年'作成
    obj.years = []
    let yearObj
    let eraName
    for (let y = firstYear; y <= lastYear; y++) {
        eraName = common.getEraName(y)
        yearObj = { label: y + '年 ' + eraName, code: y }
        obj.years.push(yearObj)
    }
    //'月'作成
    obj.months = []
    for (let m = 1; m <= 12; m++) {
        obj.months.push(m)
    }
    //'日'作成
    obj.dates = []
    for (let d = 1; d <= 31; d++) {
        obj.dates.push(d)
    }
}

//姓の自動カナ入力
function update_furigana_sei(obj) {
    obj.name.sei_kn = obj.autokanaSei.getFurigana()
}

//名の自動カナ入力
function update_furigana_mei(obj) {
    obj.name.mei_kn = obj.autokanaMei.getFurigana()
}

//契約者 姓の自動カナ入力
function update_contractor_furigana_sei(obj) {
    obj.contractorName.sei_kn = obj.autokanaContractorSei.getFurigana()
}

//契約者 名の自動カナ入力
function update_contractor_furigana_mei(obj) {
    obj.contractorName.mei_kn = obj.autokanaContractorMei.getFurigana()
}

//確認画面へ押下時
function submitCustomerForm(obj, path) {

    //エラーフラグ初期化
    obj.setErrorFlg(false)

    //エラーメッセージ初期化
    obj.error.required_sei_mei_kj = false
    obj.error.invalid_sei_mei_kj = false
    obj.error.required_sei_mei_kn = false
    obj.error.invalid_sei_mei_kn = false
    obj.error.required_pickupTell = false
    obj.error.invalid_pickupTell = false
    obj.error.invalid_pickupTell2 = false
    obj.error.required_email = false
    obj.error.invalid_email = false
    obj.error.required_birthday = false
    obj.error.invalid_birthday = false
    obj.error.required_gender = false
    obj.error.required_apply_company_name = false
    obj.error.required_apply_department = false
    obj.error.required_apply_sei_mei_kj = false
    obj.error.invalid_apply_sei_mei_kj = false
    obj.error.required_apply_sei_mei_kn = false
    obj.error.invalid_apply_sei_mei_kn = false
    obj.error.required_apply_pickupTell = false
    obj.error.invalid_apply_pickupTell = false
    obj.error.required_apply_email = false
    obj.error.invalid_apply_email = false
    obj.error.required_contract_company_name = false
    obj.error.required_contract_department = false
    obj.error.required_contract_sei_mei_kj = false
    obj.error.invalid_contract_sei_mei_kj = false
    obj.error.required_contract_sei_mei_kn = false
    obj.error.invalid_contract_sei_mei_kn = false
    obj.error.required_contract_company_zipcode = false
    obj.error.invalid_contract_company_zipcode = false
    obj.error.required_contract_company_address = false
    obj.error.required_contract_tell = false
    obj.error.invalid_contract_tell = false
    obj.error.required_employee = false
    obj.error.required_industry = false

    // 法人サイトの場合
    if(obj.siteCodeInfo[0].BIZ_FLG == '1'){

        //申込者 会社名・屋号 必須チェック
        if (obj.companyName === '') {
            obj.setErrorFlg(true)
            obj.error.required_apply_company_name = true
        }

        //申込者 所属部署・役職 必須チェック
        if (obj.department === '') {
            obj.setErrorFlg(true)
            obj.error.required_apply_department = true
        }

        //申込者 名前（漢字） 必須チェック
        if (obj.name.sei_kj === '' || obj.name.mei_kj === '') {
            obj.setErrorFlg(true)
            obj.error.required_apply_sei_mei_kj = true
        }

        //申込者 名前（漢字）S-JIS以外の文字チェック
        if (!(common.checkStr(obj.name.sei_kj) && common.checkStr(obj.name.mei_kj))) {
            obj.setErrorFlg(true)
            obj.error.invalid_apply_sei_mei_kj = true
        }

        //申込者 名前（カナ） 必須チェック
        if (obj.name.sei_kn === '' || obj.name.mei_kn === '') {
            obj.setErrorFlg(true)
            obj.error.required_apply_sei_mei_kn = true

        //申込者 名前（カナ）全角カナのみチェック
        } else if (!(common.isZenkakuKana(obj.name.sei_kn) && common.isZenkakuKana(obj.name.mei_kn))) {
            obj.setErrorFlg(true)
            obj.error.invalid_apply_sei_mei_kn = true
        }

        //電話番号必須チェック
        if (obj.pickupTell === '') {
            obj.setErrorFlg(true)
            obj.error.required_apply_pickupTell = true
        } else if (!(common.isHankakuNum(obj.pickupTell) && common.isTelMaxLength(obj.pickupTell))) {
            //電話番号 半角数字10～11桁チェック
            obj.setErrorFlg(true)
            obj.error.invalid_apply_pickupTell = true
        }

        //メールアドレス必須チェック
        if (obj.email === '') {
            obj.setErrorFlg(true)
            obj.error.required_apply_email = true
        } else if (!common.isMailAddress(obj.email)) {
            //メールアドレス形式チェック
            obj.setErrorFlg(true)
            obj.error.invalid_apply_email = true
        }

        //お申込み者がご契約者名と異なる場合
        if(obj.checkContractor){
            //契約者 会社名・屋号 必須チェック
            if (obj.contractCompanyName === '') {
                obj.setErrorFlg(true)
                obj.error.required_contract_company_name = true
            }

            //契約者 所属部署・役職 必須チェック
            if (obj.contractDepartment === '') {
                obj.setErrorFlg(true)
                obj.error.required_contract_department = true
            }
            
            //契約者 名前（漢字） 必須チェック
            if (obj.contractorName.sei_kj === '' || obj.contractorName.mei_kj === '') {
                obj.setErrorFlg(true)
                obj.error.required_contract_sei_mei_kj = true
            }

            //契約者 名前（漢字）S-JIS以外の文字チェック
            if (!(common.checkStr(obj.contractorName.sei_kj) && common.checkStr(obj.contractorName.mei_kj))) {
                obj.setErrorFlg(true)
                obj.error.invalid_contract_sei_mei_kj = true
            }

            //契約者 名前（カナ） 必須チェック
            if (obj.contractorName.sei_kn === '' || obj.contractorName.mei_kn === '') {
                obj.setErrorFlg(true)
                obj.error.required_contract_sei_mei_kn = true

            //契約者 名前（カナ）全角カナのみチェック
            } else if (!(common.isZenkakuKana(obj.contractorName.sei_kn) && common.isZenkakuKana(obj.contractorName.mei_kn))) {
                obj.setErrorFlg(true)
                obj.error.invalid_contract_sei_mei_kn = true
            }

            //契約者 会社郵便番号 必須チェック
            if (obj.contractCompanyZipcode === '') {
                obj.setErrorFlg(true)
                obj.error.required_contract_company_zipcode = true
            } else if (!common.isHankakuNum(obj.contractCompanyTell)) {
                //会社郵便番号 半角数字チェック
                obj.setErrorFlg(true)
                obj.error.invalid_contract_company_zipcode = true
            }

            //契約者 会社住所 必須チェック
            if (obj.contractCompanyAddress === '') {
                obj.setErrorFlg(true)
                obj.error.required_contract_company_address = true
            }
            
            //契約者 会社電話番号 必須チェック
            if (obj.contractCompanyTell === '') {
                obj.setErrorFlg(true)
                obj.error.required_contract_tell = true
            } else if (!(common.isHankakuNum(obj.contractCompanyTell) && common.isTelMaxLength(obj.contractCompanyTell))) {
                //会社電話番号 半角数字10～11桁チェック
                obj.setErrorFlg(true)
                obj.error.invalid_contract_tell = true
            }
        }

        //従業員数 必須チェック
        if (obj.selectEmployee === '') {
            obj.setErrorFlg(true)
            obj.error.required_employee = true
        }

        //業種 必須チェック
        if (obj.selectIndustry === '') {
            obj.setErrorFlg(true)
            obj.error.required_industry = true
        }

    // 法人サイト以外の場合
    }else{
        //名前（漢字）必須チェック
        if (obj.name.sei_kj === '' || obj.name.mei_kj === '') {
            obj.setErrorFlg(true)
            obj.error.required_sei_mei_kj = true
        }

        //名前（漢字）S-JIS以外の文字チェック
        if (!(common.checkStr(obj.name.sei_kj) && common.checkStr(obj.name.mei_kj))) {
            obj.setErrorFlg(true)
            obj.error.invalid_sei_mei_kj = true
        }

        //名前（カナ）必須チェック
        if (obj.name.sei_kn === '' || obj.name.mei_kn === '') {
            obj.setErrorFlg(true)
            obj.error.required_sei_mei_kn = true

        //名前（カナ）全角カナのみチェック
        } else if (!(common.isZenkakuKana(obj.name.sei_kn) && common.isZenkakuKana(obj.name.mei_kn))) {
            obj.setErrorFlg(true)
            obj.error.invalid_sei_mei_kn = true
        }

        //携帯電話番号必須チェック
        if (obj.pickupTell === '') {
            obj.setErrorFlg(true)
            obj.error.required_pickupTell = true
        } else if (!(common.isHankakuNum(obj.pickupTell) && common.isTelMaxLength(obj.pickupTell))) {
            //携帯電話番号 半角数字10～11桁チェック
            obj.setErrorFlg(true)
            obj.error.invalid_pickupTell = true
        }

        //ご自宅電話番号半角数字10～11桁チェック
        if (obj.pickupTell2 != '' && !(common.isHankakuNum(obj.pickupTell2) && common.isTelMaxLength(obj.pickupTell2))) {
            obj.setErrorFlg(true)
            obj.error.invalid_pickupTell2 = true
        }

        //メールアドレス必須チェック
        if (obj.email === '') {
            obj.setErrorFlg(true)
            obj.error.required_email = true
        } else if (!common.isMailAddress(obj.email)) {
            //メールアドレス形式チェック
            obj.setErrorFlg(true)
            obj.error.invalid_email = true
        }

        //生年月日必須チェック
        if (obj.birthday.year === '' || obj.birthday.month === '' || obj.birthday.date === '') {
            obj.setErrorFlg(true)
            obj.error.required_birthday = true
        } else if (!common.isEnableDate(obj.birthday.year, obj.birthday.month, obj.birthday.date)) {
            //生年月日有効日付チェック
            obj.setErrorFlg(true)
            obj.error.invalid_birthday = true
        }

        //性別必須チェック
        if (obj.gender === '') {
            obj.setErrorFlg(true)
            obj.error.required_gender = true
        }
  }

    //エラーフラグをストアにセット
    common.setStore(obj, 'errorFlg', obj.errorFlg())

    //ストアに値保持
    common.setStore(obj, 'sei_kj', obj.name.sei_kj)
    common.setStore(obj, 'mei_kj', obj.name.mei_kj)
    common.setStore(obj, 'sei_kn', obj.name.sei_kn)
    common.setStore(obj, 'mei_kn', obj.name.mei_kn)
    common.setStore(obj, 'pickupTell', obj.pickupTell)
    common.setStore(obj, 'pickupTell2', obj.pickupTell2)
    common.setStore(obj, 'email', obj.email)
    common.setStore(obj, 'birthday', obj.birthday.year + "/" + obj.birthday.month + "/" + obj.birthday.date)
    common.setStore(obj, 'gender', obj.gender)
    common.setStore(obj, 'enquete', { selected: obj.selected, freeInput: obj.freeInput })
    if(obj.siteCodeInfo[0].BIZ_FLG == '1'){
        if(obj.checkContractor){
            common.setStore(obj, 'checkContractor', obj.checkContractor)
            common.setStore(obj, 'contractorSei_kj', obj.contractorName.sei_kj)
            common.setStore(obj, 'contractorMei_kj', obj.contractorName.mei_kj)
            common.setStore(obj, 'contractorSei_kn', obj.contractorName.sei_kn)
            common.setStore(obj, 'contractorMei_kn', obj.contractorName.mei_kn)
            common.setStore(obj, 'contractCompanyName', obj.contractCompanyName)
            common.setStore(obj, 'contractDepartment', obj.contractDepartment)
            common.setStore(obj, 'contractCompanyZipcode', obj.contractCompanyZipcode)
            common.setStore(obj, 'contractCompanyAddress', obj.contractCompanyAddress)
            common.setStore(obj, 'contractCompanyTell', obj.contractCompanyTell)    
        }
        common.setStore(obj, 'companyName', obj.companyName)
        common.setStore(obj, 'department', obj.department)
        common.setStore(obj, 'selectEmployee', obj.selectEmployee)
        common.setStore(obj, 'selectIndustry', obj.selectIndustry)
    }

    //画面遷移先をセット
    common.setRoute(obj, path)
}

function autoKanaBind(obj) {
    obj.autokanaSei = AutoKana.bind('#name01', '#kana01', { katakana: true })
    obj.autokanaMei = AutoKana.bind('#name02', '#kana02', { katakana: true })
    if('1' == obj.siteCodeInfo[0].BIZ_FLG){
        obj.autokanaContractorSei = AutoKana.bind('#contractorName01', '#contractorKana01', { katakana: true })
        obj.autokanaContractorMei = AutoKana.bind('#contractorName02', '#contractorKana02', { katakana: true })
    }
}

function deleteHyphen(value) {
    if (value.includes('-')) {
        // '-'を除く
        const regex = /-/g
        return value.replace(regex, '')
    } else {
        return value
    }
}

function getDisabled(obj, questionId, answerId) {
    questionId = 'question_' + questionId
    return Array.isArray(obj.selected[questionId])
        ? !obj.selected[questionId].includes(answerId)
        : answerId !== obj.selected[questionId]
}

function initialSelected(enqueteMaster) {
    return enqueteMaster.reduce((pre, cur) => {
        if (cur.question.QUESTION_METHOD === 1) {
            pre['question_' + cur.question.ENQUETE_QUESTION_ID] = []
        } else if (cur.question.QUESTION_METHOD === 2) {
            pre['question_' + cur.question.ENQUETE_QUESTION_ID] = null
        } else if (cur.question.QUESTION_METHOD === 3) {
            pre['question_' + cur.question.ENQUETE_QUESTION_ID] = cur.answers[0].ENQUETE_ANSWER_ID
        }
        return pre
    }, {})
}

function initialFreeInput(enqueteMaster) {
    return enqueteMaster.reduce((pre, cur) => {
        // ラジオボックス・チェックボックスに「その他」欄のフリー入力
        if ([1, 2].includes(cur.question.QUESTION_METHOD)) {
            cur.answers.forEach(ans => {
                if (ans.FREE_INPUT_FLG) {
                    pre['answer_' + ans.ENQUETE_ANSWER_ID] = ''
                }
            })
        } else if (cur.question.QUESTION_METHOD === 3) {
            pre['answer_' + cur.answers[0].ENQUETE_ANSWER_ID] = ''
        }
        return pre
    }, {})

}
// メールアドレス小文字変換
function formatToLowerEmail(obj) {
    obj.email = obj.email.toLowerCase();
}

export default {
    common,
    inputRetention,
    createBirthday,
    update_furigana_sei,
    update_furigana_mei,
    update_contractor_furigana_sei,
    update_contractor_furigana_mei,
    submitCustomerForm,
    autoKanaBind,
    deleteHyphen,
    getDisabled,
    initialSelected,
    initialFreeInput,
    formatToLowerEmail
}
